import { FC, startTransition, useCallback, useEffect, useState } from 'react';

import MwdDialog from '@/components/UI/Dialog/Dialog';
import FieldGroup from '@/components/UI/Fields/FieldGroup';
import EenhedenSelect from '@/components/UI/Fields/ReactFormFields/EenhedenSelect';
import { LoaderWithOverlay } from '@/components/UI/Loader/LoaderWithOverlay';
import { RadioGroup } from '@/components/UI/RadioGroup/RadioGroup';
import { useLoading } from '@/contextProviders/loadingProvider';
import { useGetAlleEenheden } from '@/queries/stamgegevens/useGetAlleEenheden';

import usePutWtsEenheden from './usePutWtsEenheden';

import styles from '@/components/UI/Dialog/Dialog.module.css';

export type EenhedenUitsluitenDialogProps = {
  showDialog: boolean;
  handleOpenChange: (p: boolean) => void;
};

const EenhedenUitsluitenDialog: FC<EenhedenUitsluitenDialogProps> = ({ showDialog, handleOpenChange }) => {
  const { createWts } = usePutWtsEenheden();
  const { loading, setLoading } = useLoading();
  const [eenheden, setEenheden] = useState<string[]>([]);
  const [status, setStatus] = useState<'active' | 'ruledOut'>('ruledOut');
  useEffect(() => {
    if (showDialog) {
      setStatus('ruledOut');
    }
  }, [showDialog]);
  const reset = () => {
    setEenheden([]);
    setStatus('ruledOut');
    handleOpenChange(false);
  };
  const actionSubmit = useCallback(
    (__label: string) => {
      if (!eenheden.length) return; // Add error validation
      startTransition(() => createWts(eenheden, status === 'ruledOut'));
      reset();
    },
    [eenheden, status],
  );

  const { data } = useGetAlleEenheden();
  const options = (data ?? []).map((eenheid) => ({ value: eenheid, label: eenheid }));

  return (
    <>
      {loading && (
        <LoaderWithOverlay isLoading={loading} handleOpenChange={setLoading} overlayOpacity='nonTransparant' />
      )}
      <MwdDialog
        title='Wijzig status'
        className={styles.wijzigenMaterieelTypeDialogStyle}
        showDialog={showDialog}
        handleOpenChange={handleOpenChange}
      >
        <div style={{ display: 'flex', gap: 4, flexDirection: 'column' }}>
          <FieldGroup.Col boxProps={{ width: '100%' }} required fieldId='wtsNummers' label='Eenheden'>
            <EenhedenSelect
              options={options}
              selectedEenheden={eenheden}
              createOption={(label: string) => {
                return { value: label, label };
              }}
              onChange={(values) => {
                setEenheden((__) => [...values]);
              }}
            />
          </FieldGroup.Col>
          <FieldGroup.Col boxProps={{ width: '100%' }} required fieldId='wtsStatus' label='Status WTS'>
            <RadioGroup
              value={status}
              options={[
                { value: 'active', label: 'WTS actief' },
                { value: 'ruledOut', label: 'WTS uitgesloten' },
              ]}
              onChange={(newStatus) => {
                setStatus(newStatus as 'active' | 'ruledOut');
              }}
            />
          </FieldGroup.Col>
        </div>
        <MwdDialog.Footer submitCaption='Wijzigen' cancelCallback={reset} handleSubmitType={actionSubmit} />
      </MwdDialog>
    </>
  );
};
export default EenhedenUitsluitenDialog;
